import { render, staticRenderFns } from "./editasset.vue?vue&type=template&id=27f9385c&scoped=true"
import script from "./editasset.js?vue&type=script&lang=js&external"
export * from "./editasset.js?vue&type=script&lang=js&external"
import style0 from "./editasset.vue?vue&type=style&index=0&id=27f9385c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9385c",
  null
  
)

export default component.exports